import { create } from 'zustand';

type SessionStore = {
  isSessionInvalidatedModalOpen: boolean;
  setSessionInvalidatedModalOpen: (isOpen: boolean) => void;
};

export const useSessionStore = create<SessionStore>((set) => ({
  isSessionInvalidatedModalOpen: false,
  setSessionInvalidatedModalOpen: (isOpen: boolean) => set({ isSessionInvalidatedModalOpen: isOpen })
}));
